export const environment = {
  production: false,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: "authce9d77b308c149d5992a80073637e4d5",
  url: "https://api.asegurate.bocetos.co/asegurate/",
  siteKey: "6LfAbWEpAAAAACUpf7pyc9DuXXbBL9uv9Xwcp_dI",
  secretKey: "6LfAbWEpAAAAABq0Sm7jEdNqY10zWKa8JYxx48sA",
  version: "01 Feb 2024 6pm",
};